// src/components/bookings/BookingStatusBadge.jsx
import React from 'react';
import { FaCheckCircle, FaClock, FaTruck, FaUserCheck, FaBan, FaHourglassHalf } from 'react-icons/fa';

const BookingStatusBadge = ({ status }) => {
  const statusConfig = {
    booked: {
      bg: '#FEF6D7',
      color: '#FED229',
      label: 'Booked',
      icon: <FaClock />,
    },
    assigned: {
      bg: '#D3EAFF',
      color: '#437EF7',
      label: 'Assigned',
      icon: <FaUserCheck />,
    },
    out_for_delivery: {
      bg: '#FFE4E6',
      color: '#E11D48',
      label: 'Out for Delivery',
      icon: <FaTruck />,
    },
    delivered: {
      bg: '#ECFDF3',
      color: '#027A48',
      label: 'Delivered',
      icon: <FaCheckCircle />,
    },
    cancelled: {
      bg: '#FFDCE2',
      color: '#F94765',
      label: 'Cancelled',
      icon: <FaBan />,
    },
    pending: {
      bg: '#F1F3F5',
      color: '#6B7280',
      label: 'Pending',
      icon: <FaHourglassHalf />,
    },
    default: {
      bg: '#F1F3F5',
      color: '#6B7280',
      label: status || 'Unknown',
      icon: <FaClock />,
    },
  };

  const config = statusConfig[status?.toLowerCase()] || statusConfig.default;

  return (
    <span
      style={{
        padding: '6px 14px',
        borderRadius: '20px',
        fontWeight: '600',
        fontSize: '13px',
        backgroundColor: config.bg,
        color: config.color,
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
      }}
    >
      {config.icon} {config.label}
    </span>
  );
};

export default BookingStatusBadge;